
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import classNames from "classnames";
const PhoneItem = ({ phone, absolute, scrolled }) => {
    return <li className={classNames({
            "why_item": true,
            "bg": phone.bg && !scrolled,
            "absolute": absolute,
            "show": scrolled && absolute,
            "scrolled": scrolled
        })}>
        <div className={'why_item_header'}>
            <picture>
                <source srcSet={`/img/pages/home/why/${phone.icon}.webp`} type="image/webp"/>
                <source srcSet={`/img/pages/home/why/${phone.icon}.png`}/>
                <img src={`/img/pages/home/why/${phone.icon}.png`} alt={`ColdWare ${phone.name}`} width={72} height={144} className='why_item_header_icon'/>
            </picture>
            <div className={'name_price'}>
                <span className={'name'}>{phone.name}</span>
                <span className={'price'}>{phone.price}</span>
            </div>
        </div>
        <ol className={'why_item_values'}>
            {phone.values.text.map(el => {
            return <li className={'why_item_values_value'} key={el}>
                    {el}
                </li>;
        })}
        </ol>
        <ol className={'why_item_values'}>
            {phone.values.icons.map((el, i) => {
            return <li className={'why_item_values_value'} key={el + i}>
                    {el ? <img width={27} height={26} src={'/img/pages/home/why/check.svg'} alt={'check'}/> :
                    <img width={27} height={26} src={'/img/pages/home/why/uncheck.svg'} alt={'uncheck'}/>}
                </li>;
        })}
        </ol>
    </li>;
};
const Why = ({ t }) => {
    const why = t('home:why', {}, { returnObjects: true });
    const [scrolled, setScrolled] = useState(false);
    const Title = ({ title }) => {
        return <li className={'titles_list_item'}>
            {title}
        </li>;
    };
    useEffect(() => {
        let scrollableBlock = document.querySelector('.why_content_items');
        const detectScroll = () => {
            const scrollLeft = scrollableBlock.scrollLeft;
            setScrolled(true);
            if (scrollLeft === 0) {
                setScrolled(false);
            }
        };
        scrollableBlock.addEventListener('scroll', detectScroll);
        return () => {
            scrollableBlock.addEventListener('scroll', detectScroll);
        };
    }, []);
    return (<section className={'why'}>
            <div className="container">
                <h2 className={'why_title'}>{why.title}</h2>
            </div>
            <div className={classNames({
            "container": true,
            "scroll": true,
            "scrolled": scrolled
        })}>
                <div className="why_content">
                    <div className={'why_content_titles'}>
                        <svg className={'titles_icon'} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.75491 0V4.67443H11.2397L11.2397 0H8.75491ZM8.75491 15.6401V20.0017H11.2397L11.2397 15.6401H8.75491ZM19.9998 11.2433H15.6381V8.75845L19.9998 8.75845V11.2433ZM0 11.2433H4.67443V8.75845L0 8.75845V11.2433ZM16.2105 18.1264L10.3121 12.228L12.0691 10.471L17.9676 16.3694L16.2105 18.1264ZM2.0299 3.94522L7.92832 9.84365L9.68537 8.08661L3.78694 2.18818L2.0299 3.94522ZM17.9691 3.9451L12.0707 9.84353L10.3137 8.08649L16.2121 2.18806L17.9691 3.9451ZM3.78695 18.1263L9.68538 12.2279L7.92834 10.4709L2.02991 16.3693L3.78695 18.1263Z" fill="#000034" fillOpacity="0.5"/>
                        </svg>
                        <p className={'why_content_titles_scroll'}>{why.scroll}</p>
                        <ul className={'titles_list'}>
                            {why.titles.map(el => {
            return <Title key={el} title={el}/>;
        })}
                        </ul>
                    </div>
                    <ul className={classNames({
            "why_content_items": true,
            "scrolled": scrolled
        })}>
                        <PhoneItem scrolled={scrolled} absolute={true} phone={why.items[0]}/>
                        {why.items.map(phone => {
            return <PhoneItem key={phone.name} phone={phone} scrolled={scrolled}/>;
        })}
                    </ul>
                </div>

            </div>
        </section>);
};
export default Why;

    async function __Next_Translate__getStaticProps__19763359621__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Why/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19763359621__ as getStaticProps }
  